import Vue from 'vue'
import { message, Pagination, Spin } from 'ant-design-vue'
import { NotifyOptions, NotifyMessage } from 'vant/types/notify'

Vue.use(Pagination)
Vue.use(Spin)

Vue.prototype.$notify = (options: NotifyMessage | NotifyOptions) => {
  if (typeof options !== 'object') {
    options = {
      message: options
    }
  }
  let type: 'success' | 'info' | 'warning' | 'error' | 'loading'
  switch (options.type) {
    case 'primary':
      type = 'info'
      break
    case 'danger':
      type = 'error'
      break
    default:
      type = options.type
      break
  }
  return message.open({
    content: options.message as string,
    type,
    duration: options.duration,
    onClose: options.onClose
  })
}
